import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {HoverNavigationButtonContainerBox} from "./boxes/hover-navigation-button-container.box";
import {MiniOrbitArenasHeaderComponent} from "../arenas-header/mini-orbit-arenas-header.component";

export class HoverNavigationButtonComponent extends OrbitComponent {

    private _openNavigationDialog() {
        this.services.dialog.showModal(() => <MiniOrbitArenasHeaderComponent />, {
            title: this.services.translation.translate('FILTER'),
            applyMaxHeight: true
        });
    }

    render() {
        return (
            <HoverNavigationButtonContainerBox>
                <Button preset={"primary"} icon={{Component: this.services.theme.currentTheme.icons.addIcon}} onClick={() => this._openNavigationDialog()}>
                    {this.services.translation.translate('FILTER')}
                </Button>
            </HoverNavigationButtonContainerBox>
        );
    }
}
